import * as React from 'react';
import { SVGProps } from 'react';

const IconDataSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 6.5V5.312s.446-.292 1.136-.668C5.817 4 7.466 3.334 9.25 3.334c1.586 0 2.612.527 3.257 1.157-.007.009-.007.59 0 1.509-.074-.37-.333-.706-.6-.945-.521-.465-1.135-.722-2.657-.722-1.549 0-3.026.584-4.136 1.19C4.49 5.862 4 6.18 3.5 6.5Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M7 6C4.186 6 3.5 8.833 3.5 8.833V10.5c1.033-.996 2-2 4-2 2.083 0 4.306 1.306 5 2v-2S9.814 6 7 6Z"
      fill="var(--color-bg-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.51 11.395c.117-.041.248-.084.394-.126.778-.222 1.97-.436 3.68-.436 1.707 0 3.098.214 4.066.429.484.107.59.128.85.21v1.044a13.539 13.539 0 0 0-1.067-.278 17.853 17.853 0 0 0-3.85-.405c-1.624 0-2.724.203-3.404.398a3.25 3.25 0 0 0-.67.252v-1.088Z"
      fill="var(--color-bg-alert)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14H1v-1h2v2H2v-1ZM14 2h1v1h-2V1h1v1ZM14 14v1h-1v-2h2v1h-1ZM2 2V1h1v2H1V2h1ZM2 4.5v-1h1v1H2ZM4.5 2h-1v1h1V2Zm1 0v1h1V2h-1Zm2 0v1h1V2h-1Zm2 0v1h1V2h-1Zm2 0v1h1V2h-1ZM14 3.5h-1v1h1v-1Zm0 2h-1v1h1v-1Zm0 2h-1v1h1v-1Zm0 2h-1v1h1v-1Zm0 2h-1v1h1v-1ZM12.5 14v-1h-1v1h1Zm-2 0v-1h-1v1h1Zm-2 0v-1h-1v1h1Zm-2 0v-1h-1v1h1Zm-2 0v-1h-1v1h1ZM2 12.5h1v-1H2v1Zm0-2h1v-1H2v1Zm0-2h1v-1H2v1Zm0-2h1v-1H2v1Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconDataSizeS;
